import { Injectable } from '@angular/core';
import { SettingMailConfig } from '@model/setting-mail-config';
import { ApiService } from '@theme/utils/api.service';
import { NoInternetHelper } from '@theme/utils/no-internet-helper';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MailConfigService {
  mailConfig: SettingMailConfig;
  public edit: boolean = false;
  public type: string = "";
  private url = "private/extra/setting/mailconfig";

  constructor(private api: ApiService) {}

  setMailConfig(mailConfig: SettingMailConfig) {
    this.mailConfig = mailConfig;
  }

  getMailConfig(): SettingMailConfig {
    return this.mailConfig;
  }

  getSingle(): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/show`).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  update(data: SettingMailConfig): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/update`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  testConnection(): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/test`, {}).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
}
